module.exports = __webpack_public_path__ + "img/622.97649291.jpg";